export enum BIM360IssueActivityType {
    VIEW = 'quality-issue-view',
    ATTACH = 'quality-issue-attach',
    CREATE = 'quality-issue-create',
    COMMENT = 'quality-issue-comment',
    OPEN = 'quality-issue-open',
    CLOSED = 'quality-issue-closed',
    ANSWERED = 'quality-issue-answered',
    ASSIGN = 'quality-issue-assign',
    VOID = 'quality-issue-void',
    DUE_DATE = 'quality-issue-due-date',
    EDIT = 'quality-issue-edit',
}

export abstract class BIM360IssueActivityV2 {
    public id: string = '';
    public activity! : IssueActivity;
    public submitted: string = '';
}

export type IssueActivityObjectType = QualityIssueAnswered | QualityIssueAssign | QualityIssueClosed | QualityIssueOpen
                                | QualityIssueCreate | QualityIssueEdit | QualityIssueDueDate | QualityIssueComment
                                | QualityIssueVoid | QualityIssueAttach;
export class IssueActivity {
    public published: string = '';
    public generator: string = '';
    public verb!: BIM360IssueActivityType;
    public actor!: IssueActor;
    public object!: IssueActivityObjectType; // BIM360IssueActivityType has different attributes

    constructor (json:any)
    {
        this.published = json.published || undefined;
        this.generator = json.generator || undefined;
        this.verb = json.verb || undefined;
        this.actor = new IssueActor(json.actor);
        switch (this.verb) {
            case BIM360IssueActivityType.ANSWERED:
                this.object = new QualityIssueAnswered(json.object);
              break;
            case BIM360IssueActivityType.ASSIGN:
                this.object = new QualityIssueAssign(json.object);
              break;
            case BIM360IssueActivityType.CLOSED:
                this.object = new QualityIssueClosed(json.object);
              break;
            case BIM360IssueActivityType.OPEN:
                this.object = new QualityIssueOpen(json.object);
                break;
            case BIM360IssueActivityType.CREATE:
                this.object = new QualityIssueCreate(json.object);
                break;
            case BIM360IssueActivityType.EDIT:
                this.object = new QualityIssueEdit(json.object);
                break;
            case BIM360IssueActivityType.DUE_DATE:
                this.object = new QualityIssueDueDate(json.object);
                break;
            case BIM360IssueActivityType.COMMENT:
                this.object = new QualityIssueComment(json.object);
                break;
            case BIM360IssueActivityType.VOID:
                this.object = new QualityIssueVoid(json.object);
                break;
            case BIM360IssueActivityType.ATTACH:
                this.object = new QualityIssueAttach(json.object);
            default:
                this.object = json.object;
        }
        
    }
}

class IssueActor {
    public id: string = '';
    public displayName: string = '';
    public idType: string = '';
    public name: string = '';
    public serviceId: string = '';
    constructor (json:any)
    {
        this.id = json.id || undefined;
        this.displayName = json.displayName  || undefined;
        this.idType = json.idType  || undefined;
        this.name = json.name  || undefined;
        this.serviceId = json.serviceId  || undefined;
    }

}

class IssueProject {
    public id: string = '';
    public displayName: string = '';
    public accountId: string = '';
    public containerId: string = '';
    public serviceId: string = '';
    constructor (json:any)
    {
        this.id = json.id || undefined;
        this.displayName = json.displayName || undefined;
        this.accountId = json.accountId || undefined;
        this.containerId = json.containerId || undefined;
        this.serviceId = json.serviceId || undefined;
    }
}

export class ChangedObject {
    public id: string = "";
    public displayName: string = "";
    public after: string = "";
    public before: string = "";
    public property: string = "";
    constructor (json:any)
    {
        this.id = json.id || undefined;
        this.displayName = json.displayName || undefined;
        this.after = json.after || undefined;
        this.before = json.before || undefined;
        this.property = json.property || undefined;
    }
}

class IssueActivityObject {
    public answer: string = "";
    public assigned_to: string = "";
    public assigned_to_type: string = "";
    public created_at: string = "";
    public displayName: string = "";
    public id: string = "";
    public project!: IssueProject; 
    public status: string = "";
    public title: string = "";
    public updated_at: string  = "";
    constructor (json:any)
    {
        this.answer = json.answer || undefined;
        this.assigned_to = json.assigned_to || undefined;
        this.assigned_to_type = json.assigned_to_type || undefined;
        this.created_at = json.created_at || undefined;
        this.displayName = json.displayName || undefined;
        this.id = json.id || undefined;
        this.project = json.project || undefined;
        this.status = json.status || undefined;
        this.title = json.title || undefined;
        this.updated_at = json.updated_at || undefined;
    }
}

class QualityIssueCreate extends IssueActivityObject {
    public changed_assigned_to!: ChangedObject | undefined;
    public changed_assigned_to_type!: ChangedObject| undefined;
    public changed_description!: ChangedObject| undefined;
    public changed_due_date!: ChangedObject| undefined;
    public changed_issue_subtype_id!: ChangedObject| undefined;
    public changed_issue_type_id!: ChangedObject| undefined;
    public changed_location_description!: ChangedObject| undefined;
    public changed_owner!: ChangedObject| undefined;
    public changed_root_cause_id!: ChangedObject| undefined;
    public changed_status!: ChangedObject| undefined;
    public changed_title!: ChangedObject| undefined;
    constructor (json:any) 
    {
        super(json);
        this.changed_assigned_to = json.changed_assigned_to ? new ChangedObject(json.changed_assigned_to) : undefined;
        this.changed_assigned_to_type = json.changed_assigned_to_type ? new ChangedObject(json.changed_assigned_to_type): undefined;
        this.changed_description = json.changed_description ? new ChangedObject(json.changed_description): undefined;
        this.changed_due_date = json.changed_due_date ? new ChangedObject(json.changed_due_date): undefined;
        this.changed_issue_subtype_id = json.changed_issue_subtype_id ? new ChangedObject(json.changed_issue_subtype_id): undefined;
        this.changed_issue_type_id = json.changed_issue_type_id ? new ChangedObject(json.changed_issue_type_id): undefined;
        this.changed_location_description = json.changed_location_description ? new ChangedObject(json.changed_location_description): undefined;
        this.changed_owner = json.changed_owner ? new ChangedObject(json.changed_owner): undefined;
        this.changed_root_cause_id = json.changed_root_cause_id ? new ChangedObject(json.changed_root_cause_id): undefined;
        this.changed_status = json.changed_status ? new ChangedObject(json.changed_status): undefined;
        this.changed_title = json.changed_title ? new ChangedObject(json.changed_title): undefined;
    }
}

class QualityIssueComment extends IssueActivityObject {
    public changed_body!: ChangedObject
    public comment =  {
        displayName: "",
        id: ""
    }
    constructor (json:any) 
    {
        super(json);
        this.changed_body = new ChangedObject(json.changed_body);
        this.comment.displayName = json?.comment?.displayName || undefined;
        this.comment.id = json?.comment?.id || undefined;
    }
}

class QualityIssueOpen extends IssueActivityObject {
    public changed_status!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_status = new ChangedObject(json.changed_status);
    }
}

class QualityIssueClosed extends IssueActivityObject {
    public changed_status!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_status = new ChangedObject(json.changed_status);
    }
}

class QualityIssueAnswered extends IssueActivityObject {
    public changed_status!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_status = new ChangedObject(json.changed_status);
    }
}
class QualityIssueAssign extends IssueActivityObject {
    public changed_assigned_to!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_assigned_to = new ChangedObject(json.changed_assigned_to);
    }
}
class QualityIssueVoid extends IssueActivityObject {
    public changed_status!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_status = new ChangedObject(json.changed_status);
    }
}
class QualityIssueDueDate extends IssueActivityObject {
    public changed_due_date!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.changed_due_date = new ChangedObject(json.changed_due_date);
    }
}
export class QualityIssueEdit extends IssueActivityObject {
    public changed_issue_subtype_id: ChangedObject | undefined;
    public changed_title: ChangedObject | undefined;
    public changed_custom_attributes: ChangedObject | undefined;
    public changed_description: ChangedObject | undefined;
    public changed_root_cause_id: ChangedObject | undefined;
    constructor (json:any) 
    {
        super(json);
        this.changed_title = json.changed_title ? new ChangedObject(json.changed_title) : undefined;
        this.changed_issue_subtype_id = json.changed_issue_subtype_id ? new ChangedObject(json.changed_issue_subtype_id) : undefined;
        this.changed_custom_attributes = json.changed_custom_attributes ? new ChangedObject(json.changed_custom_attributes) : undefined;
        this.changed_description = json.changed_description ? new ChangedObject(json.changed_description) : undefined;
        this.changed_root_cause_id = json.changed_root_cause_id ? new ChangedObject(json.changed_root_cause_id) : undefined;
    }
}

class QualityIssueAttach extends IssueActivityObject {
    public attachment = {
        attachmentType: "",
        displayName: "",
        id: "",
        name: "",
        urn: "",
        urn_type: ""
    };
    public changed_attachment_type!: ChangedObject;
    public changed_name!: ChangedObject;
    public changed_urn!: ChangedObject;
    public changed_urn_type!: ChangedObject;
    constructor (json:any) 
    {
        super(json);
        this.attachment.attachmentType = json?.attachment?.attachmentType || undefined;
        this.attachment.displayName = json?.attachment?.displayName || undefined;
        this.attachment.id = json?.attachment?.id || undefined;
        this.attachment.name = json?.attachment?.name || undefined;
        this.attachment.urn = json?.attachment?.urn || undefined;
        this.attachment.urn_type = json?.attachment?.urn_type || undefined;
        this.changed_attachment_type = new ChangedObject(json.changed_attachment_type);
        this.changed_name = new ChangedObject(json.changed_attachment_type);
        this.changed_urn = new ChangedObject(json.changed_attachment_type);
        this.changed_urn_type = new ChangedObject(json.changed_attachment_type);
    }
}
